/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/reducerGoCampaign_PoliticalDistrictGroups.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for Political District Groups
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Saturday, July 06, 2019 - 06:10:29 PM (CST)
 *  
 *  Notes:
 *
 *  
 *  Revisions:
 *      07/06/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    POLITICALDISTRICTGROUP_LIST_CONTAINER_LOADED,
    POLITICALDISTRICTGROUP_LIST_CONTAINER_UNLOADED,
    POLITICALDISTRICTGROUP_LIST_TABLE_LOADED,
    POLITICALDISTRICTGROUP_LIST_TABLE_UNLOADED,

    POLITICALDISTRICTGROUP_LIST_CHANGE_GROUP,

    POLITICALDISTRICTGROUP_SELECT_ROW,
    POLITICALDISTRICTGROUP_ADD,
    POLITICALDISTRICTGROUP_EDIT,
    POLITICALDISTRICTGROUP_DELETE,
    POLITICALDISTRICTGROUP_OPEN_WARNING,
    POLITICALDISTRICTGROUP_CLOSE_WARNING,
    POLITICALDISTRICTGROUP_DELETE_DISABLE,

    POLITICALDISTRICTGROUP_SET_GROUP_SELECT,

    POLITICALDISTRICTGROUP_EDIT_CONTAINER_LOADED,
    POLITICALDISTRICTGROUP_EDIT_CONTAINER_UNLOADED,
    POLITICALDISTRICTGROUP_EDIT_FORM_LOADED,
    POLITICALDISTRICTGROUP_EDIT_FORM_UNLOADED,
    POLITICALDISTRICTGROUP_EDIT_DATA_LOAD,
    POLITICALDISTRICTGROUP_EDIT_CONTAINER_SUBMIT,
    POLITICALDISTRICTGROUP_EDIT_CONTAINER_CANCEL
} from '../constants/actionTypeGoCampaign_PoliticalDistrictGroups';

const defaultState = {
    refreshList: false,
    danger: false,
    politicaldistrictgroupid: 0,
    countryid: 0,
    stateid: 0,
    countyid: 0,
    cityid: 0,
    zipcode: '',
    name: '',
    description: '',
    orderid: 0,
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case POLITICALDISTRICTGROUP_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                politicaldistrictgroups: action.payload[0] ? action.payload[0].records : null,
                countries: action.payload[1] ? action.payload[1].records : null,
                states: action.payload[2] ? action.payload[2].records : null,
                counties: action.payload[3] ? action.payload[3].records : null,
                cities: action.payload[4] ? action.payload[4].records : null,
            }
        case POLITICALDISTRICTGROUP_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case POLITICALDISTRICTGROUP_LIST_CHANGE_GROUP:
            return {
                ...state,
                [action.key]: action.payload ? action.payload : []
            }
        case POLITICALDISTRICTGROUP_SELECT_ROW:
            return {
                ...state,
                politicaldistrictgroupid: action.id
            }
        case POLITICALDISTRICTGROUP_ADD:
            return {
                ...state
            }
        case POLITICALDISTRICTGROUP_EDIT:
            return {
                ...state,
                politicaldistrictgroupid: action.id
            }
        case POLITICALDISTRICTGROUP_DELETE:
            return {
                ...state,
                politicaldistrictgroupid: null
            }
        case POLITICALDISTRICTGROUP_DELETE_DISABLE:
            return {
                ...state,
                disableDelete: action.disabled
            }
        case POLITICALDISTRICTGROUP_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case POLITICALDISTRICTGROUP_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case POLITICALDISTRICTGROUP_EDIT_CONTAINER_LOADED:
        case POLITICALDISTRICTGROUP_EDIT_DATA_LOAD:
            return {
                ...state,
                politicaldistrictgroupid: action.payload[0] ? action.payload[0].politicaldistrictgroupid : 0,
                countryid: action.payload[0] ? action.payload[0].countryid : 0,
                country: action.payload[1] ? action.payload[1].name : action.payload[0] ? action.payload[0].country : '',
                stateid: action.payload[0] ? action.payload[0].stateid : 0,
                state: action.payload[2] ? action.payload[2].name : action.payload[0] ? action.payload[0].state : '',
                countyid: action.payload[0] ? action.payload[0].countyid : 0,
                county: action.payload[3] ? action.payload[3].name : action.payload[0] ? action.payload[0].county : '',
                cityid: action.payload[0] ? action.payload[0].cityid : 0,
                city: action.payload[0] ? action.payload[0].city : '',
                zipcodeid: action.payload[0] ? action.payload[0].zipcodeid : 0,
                zipcode: action.payload[0] ? action.payload[0].zipcode : '',
                name: action.payload[0] ? action.payload[0].name : '',
                description: action.payload[0] ? action.payload[0].description : '',
                orderid: action.payload[0] ? action.payload[0].orderid : 0,
                createdate: action.payload[0] ? action.payload[0].createdate : '',
                modifydate: action.payload[0] ? action.payload[0].modifydate : ''
            }
        case POLITICALDISTRICTGROUP_SET_GROUP_SELECT:
            return {
                ...state,
                [action.key]: action.payload ? action.payload : []
            }
        case POLITICALDISTRICTGROUP_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case POLITICALDISTRICTGROUP_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case POLITICALDISTRICTGROUP_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case POLITICALDISTRICTGROUP_LIST_CONTAINER_UNLOADED:
        case POLITICALDISTRICTGROUP_LIST_TABLE_UNLOADED:
        case POLITICALDISTRICTGROUP_EDIT_CONTAINER_UNLOADED:
        case POLITICALDISTRICTGROUP_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/reducerGoCampaign_PoliticalDistrictGroups.js